import { Text } from 'slate';

function textSerializer(textElement: Text) {
  const { text } = textElement;
  return `{{#text}}${encodeURIComponent(text)}{{/text}}`;
}

export default textSerializer;
